/**
 * VUEX module for handling app notifications
 * @author      Jeff Adams <jeff@tinyfly.com>
 * @copyright   Traxo, Inc. 2018
 */

let notificationId = 1;

// -----------------------------------------------------------------
export const state = {
  /*
    The complete notification object
    @typedef {Object} notification
    @property {('resource'|'error'|'success'|'flash')} type - The type of notification
    @property {Number} [status] - The http status code of the notification (Optional)
    @property {String} [message] - The message to display to the user (Optional if type is 'resource' otherwise required)
  */
  notifications: [],
};

// -----------------------------------------------------------------
export const getters = {
  /**
   * Return all notifications by a certain type
   * @param {String} type
   * @returns {Array}
   */
  getNotificationsByType: (state) => (type) => {
    return state.notifications.filter((notification) => notification.type === type);
  },

  /**
   * Return all notifications except ones with the specified type
   * @param {String} type
   * @returns {Array}
   */
  notificationsExceptType: (state) => (type) => {
    return state.notifications.filter((notification) => notification.type !== type);
  },
};

// -----------------------------------------------------------------
export const mutations = {
  /**
   * Adds a notification onto the state array. Setting an id and
   * incrementing that id by one for the next notification
   * @param {Object} state
   * @param {Object} notification
   */
  ADD_NOTIFICATION(state, notification) {
    state.notifications.push({
      ...notification,
      id: notificationId++,
    });
  },

  /**
   * Removes a notification onto the state array
   * @param {Object} state
   * @param {Object} notificationToRemove
   */
  REMOVE_NOTIFICATION(state, notificationToRemove) {
    state.notifications = state.notifications.filter((notification) => {
      // return all notifications which don't match the id
      return notification.id !== notificationToRemove.id;
    });
  },
};

// -----------------------------------------------------------------
export const actions = {
  create({ commit }, notification) {
    commit('ADD_NOTIFICATION', notification);
  },

  remove({ commit }, notificationToRemove) {
    if (Array.isArray(notificationToRemove)) {
      notificationToRemove.forEach((notification) => {
        commit('REMOVE_NOTIFICATION', notification);
      });
    } else {
      commit('REMOVE_NOTIFICATION', notificationToRemove);
    }
  },
};
